import { observable } from "mobx";
import PatchNotes from "../modules/PatchNotes/PatchNotes";
import { patchNotes, updateComponent } from "../_services";
import { IPatch, IPatchNotes} from "../_types/interfaces";


export const patchNotesStore = observable({
    textPatchNote: "",
    isLoaded: false,

    async loadLocalPatchNotes(serviceName: string) {
        patchNotesStore.isLoaded = true;
        try {
            const response = await patchNotes.getLocalPatchNotes(serviceName);

            patchNotesStore.textPatchNote = response;
        } catch (errors) 
        {
            console.log(errors);
        }
        patchNotesStore.isLoaded = false;
    },

    async loadGlobalPatchNote(serviceName: string) {
        patchNotesStore.isLoaded = true;
        try {
            const url = await updateComponent.getAddress();
            const response = await patchNotes.getGlobalPatchNote(url, serviceName);

            patchNotesStore.textPatchNote = response;
        } catch (errors) 
        {
            console.log(errors);
        }
        patchNotesStore.isLoaded = false;
    },

    async loadLocalPatchNotesService(serviceName: string) {
        patchNotesStore.isLoaded = true;
        try {
            const response = await patchNotes.getLocalPatchNotesService(serviceName);

            patchNotesStore.textPatchNote = response;
        } catch (errors) 
        {
            console.log(errors);
        }
        patchNotesStore.isLoaded = false;
    },

});
